import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSharedModule } from '@fuse/shared.module';

import { FileUploadDialogComponent } from 'app/main/file-upload/file-upload-dialog/file-upload-dialog.component';
import {
    MatIconModule,
    MatRippleModule,
    MatDialogModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
} from '@angular/material';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromFileUpload from 'app/main/file-upload//file-upload.reducer';
import { FileUploadEffects } from 'app/main/file-upload//file-upload.effects';
import { FileUploadService } from 'app/main/file-upload/file-upload.service';

@NgModule({
    declarations: [FileUploadDialogComponent],
    imports: [
        RouterModule,
        FuseSharedModule,
        MatIconModule,
        MatCheckboxModule,
        MatRippleModule,
        MatDialogModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        MatRadioModule,
        MatProgressBarModule,
        MaterialFileInputModule,
        MatProgressSpinnerModule,
        StoreModule.forFeature('fileUpload', fromFileUpload.reducer),
        EffectsModule.forFeature([FileUploadEffects]),

    ],
    exports: [FileUploadDialogComponent],
    entryComponents: [FileUploadDialogComponent],
    providers: [FileUploadService]
})
export class FileUploadModule {}
